import { render, staticRenderFns } from "./BtcChart.vue?vue&type=template&id=c92bf89a&"
import script from "./BtcChart.vue?vue&type=script&lang=js&"
export * from "./BtcChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports